(function () {
  const DURATION_MS = 30 * 60 * 1000;
  const KEY = 'cartReservationExpiry';

  const setExpiry = () => {
    const expiry = Date.now() + DURATION_MS;
    sessionStorage.setItem(KEY, expiry);
    return expiry;
  };

  const getExpiry = () => {
    const stored = +sessionStorage.getItem(KEY);
    return stored > Date.now() ? stored : null;
  };

  const ensureExpiry = () => getExpiry() || setExpiry();

  function clearCartAndReload() {
    fetch('/cart/clear.js', { method: 'POST' }).then(() => window.location.reload());
  }

  function render(expiry) {
    const remaining = expiry - Date.now();
    const el = document.querySelector('[data-cart-timer]');

    if (remaining <= 0) {
      sessionStorage.removeItem(KEY);
      clearInterval(window.__cartTimer);
      clearCartAndReload();
      return;
    }

    if (el) {
      const m = Math.floor(remaining / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      el.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
  }

  function start() {
    const expiry = ensureExpiry();
    clearInterval(window.__cartTimer);
    render(expiry);
    window.__cartTimer = setInterval(() => render(expiry), 1000);
  }

  function init() {
    if ((window.__cartItemCount || 0) > 0) {
      start();
    } else {
      sessionStorage.removeItem(KEY);
    }
  }

  // Reset bei jedem erfolgreichen /cart/add, unabhängig vom Theme-Markup
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    const isAdd = url?.includes('/cart/add');
    return origFetch.apply(this, args).then((res) => {
      if (isAdd && res.ok) { setExpiry(); start(); }
      return res;
    });
  };

  document.addEventListener('cart:updated', start); // Blum/Dawn-Event, falls vorhanden
  document.addEventListener('DOMContentLoaded', init);
})();